import axios from '../../helpers/interceptors';

import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    GET_LATEST_NEWS_STARTED,
    GET_LATEST_NEWS_SUCCESS,
    GET_LATEST_NEWS_FAILURE,
    GET_POST_STARTED,
    GET_POST_SUCCESS,
    GET_POST_FAILURE,
    GET_NONCE_STARTED,
    GET_NONCE_SUCCESS,
    GET_NONCE_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_WITH_HONEE_STARTED,
    LOGIN_WITH_HONEE_SUCCESS,
    LOGIN_WITH_HONEE_FAILURE,
    SEND_IDO_FORM_STARTED,
    SEND_IDO_FORM_SUCCESS,
    SEND_IDO_FORM_FAILURE
} from "./types";

import {api} from "../../api";
// // axios.defaults.withCredentials = true;
const host = api.host;


export const test = data => ({
    type: TEST,
    payload: data
});

export const setAuthorizationStatus = data => ({
    type: SET_AUTHORIZATION_STATUS,
    payload: data
});

export const getLatestNews = () => {
    let url = api.host + api.news.latest;
    // let url = 'https://apis.omt.technology/api/v1/posts/latest'


    return dispatch => {
        dispatch(getLatestNewsStarted());
        axios.get(url)
            .then(res => {
                dispatch(getLatestNewsSuccess(res.data.response.posts));
            })
            .catch(err => {
                dispatch(getLatestNewsFailure(err));
            });
    };
};

const getLatestNewsStarted = () => ({
    type: GET_LATEST_NEWS_STARTED
});

export const getLatestNewsSuccess = serverReport => ({
    type: GET_LATEST_NEWS_SUCCESS,
    payload: serverReport
});

export const getLatestNewsFailure = error => ({
    type: GET_LATEST_NEWS_FAILURE,
    payload: error
});

export const getPost = (id) => {
    let url = host + api.news.post + `/${id}`;
    // let url = 'https://apis.omt.technology/api/v1/posts' + `/${id}`;

    return dispatch => {
        dispatch(getPostStarted());
        axios.get(url)
            .then(res => {
                dispatch(getPostSuccess(res.data.response.post));
            })
            .catch(err => {
                dispatch(getPostFailure(err));
            });
    };
};

const getPostStarted = () => ({
    type: GET_POST_STARTED
});

export const getPostSuccess = serverReport => ({
    type: GET_POST_SUCCESS,
    payload: serverReport
});

export const getPostFailure = error => ({
    type: GET_POST_FAILURE,
    payload: error
});


export const getNonce = (data) => {
    let url = api.host + api.authorization.getNonce;


    return dispatch => {
        dispatch(getNonceStarted());
        axios.post(url, data)
            .then(res => {
                dispatch(getNonceSuccess(res.data.response?.nonce));
            })
            .catch(err => {
                dispatch(getNonceFailure(err));
            });
    };
};

const getNonceStarted = () => ({
    type: GET_NONCE_STARTED
});

export const getNonceSuccess = serverReport => ({
    type: GET_NONCE_SUCCESS,
    payload: serverReport
});

export const getNonceFailure = error => ({
    type: GET_NONCE_FAILURE,
    payload: error
});


export const login = (data) => {
    let url = api.host + api.authorization.login;


    return dispatch => {
        dispatch(loginStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('lp-token', res.data.response?.token);
                dispatch(loginSuccess(res.data.response));
                dispatch(setAuthorizationStatus(res.data.response?.token))
            })
            .catch(err => {
                dispatch(loginFailure(err));
            });
    };
};

const loginStarted = () => ({
    type: LOGIN_STARTED
});

export const loginSuccess = serverReport => ({
    type: LOGIN_SUCCESS,
    payload: serverReport
});

export const loginFailure = error => ({
    type: LOGIN_FAILURE,
    payload: error
});


export const loginWithHonee = (data) => {
    let url = api.host + api.authorization.loginWH;


    return dispatch => {
        dispatch(loginWithHoneeStarted());
        axios.post(url, data)
            .then(res => {
                localStorage.setItem('lp-token', res.data.response?.token);
                dispatch(loginWithHoneeSuccess(res.data.response));
                dispatch(setAuthorizationStatus(res.data.response?.token))
            })
            .catch(err => {
                dispatch(loginWithHoneeFailure(err));
            });
    };
};

const loginWithHoneeStarted = () => ({
    type: LOGIN_WITH_HONEE_STARTED
});

export const loginWithHoneeSuccess = serverReport => ({
    type: LOGIN_WITH_HONEE_SUCCESS,
    payload: serverReport
});

export const loginWithHoneeFailure = error => ({
    type: LOGIN_WITH_HONEE_FAILURE,
    payload: error
});


export const sendIdoForm = (data) => {
    let url = api.host + api.public.idoForm;


    return dispatch => {
        dispatch(sendIdoFormStarted());
        axios.post(url, data)
            .then(res => {
                dispatch(sendIdoFormSuccess(res));
            })
            .catch(err => {
                dispatch(sendIdoFormFailure(err?.response?.data?.errors));
            });
    };
};

const sendIdoFormStarted = () => ({
    type: SEND_IDO_FORM_STARTED
});

export const sendIdoFormSuccess = serverReport => ({
    type: SEND_IDO_FORM_SUCCESS,
    payload: serverReport
});

export const sendIdoFormFailure = error => ({
    type: SEND_IDO_FORM_FAILURE,
    payload: error
});

